import { useContext, useEffect, useState, useRef } from "react";
import { Layout } from "antd";
import { useMediaQuery } from "react-responsive";
import Loading from "../../components/BussinesPartner/utils/Loading";
import UserHeaderProfile from "./UserHeaderProfile";
import { UserSider } from "../templates/UserSider";
import { FollowersSider } from "../templates/FollowersSider";
import { UiTextsContext, UserDataContext } from "../../contexts/Contexts";
import NewSideBar from "../../components/NewSideBar/NewSideBar";
import {
  postListConnectionsAndFollowersService,
  getImagePublicationService,
} from "../../../infrastructure/services/PublicationService";
import "./Profile.css";
import NewNavBar from "../newHome/NewNavBar/NewNavBar";

const { Header, Sider, Content } = Layout;

const LayoutProfile = ({ routes }) => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const { texts } = useContext(UiTextsContext);
  const { userData } = useContext(UserDataContext);

  // Listas
  const [following, setFollowing] = useState([]);
  const [followers, setFollowers] = useState([]);
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);

  // Estado para mostrar/ocultar el sider de followers
  const [showFollowers, setShowFollowers] = useState(true);
  const prevScrollY = useRef(0);
  const scrollContainerRef = useRef(null);

  // Carga de datos
  const postListFollowing = async (number) => {
    setLoading(true);
    try {
      const req = {
        IdUsuario: userData?.idUsuario,
        Lista: number,
      };
      const response = await postListConnectionsAndFollowersService(req);

      // Obtener imágenes
      const listWithImages = await Promise.all(
        response.map(async (prop) => {
          try {
            if (prop?.fotoPerfil) {
              const imageReq = {
                IdResource: prop.fotoPerfil,
                idUsuario: prop.idAmigo,
              };
              const imageData = await getImagePublicationService(imageReq);
              return {
                ...prop,
                imageUrl: imageData?.content || "/img/properties/casa.png",
              };
            }
            return {
              ...prop,
              imageUrl: "/img/properties/casa.png",
            };
          } catch {
            return {
              ...prop,
              imageUrl: "/img/properties/casa.png",
            };
          }
        })
      );

      switch (number) {
        case 1:
          setFollowing(listWithImages);
          break;
        case 2:
          setFollowers(listWithImages);
          break;
        case 3:
          setConnections(listWithImages);
          break;
        default:
      }
    } catch (error) {
      console.error("Error al cargar la lista:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    postListFollowing(1);
    postListFollowing(2);
    postListFollowing(3);
  }, []);

  // Manejo de scroll
  const handleScroll = () => {
    const currentY = scrollContainerRef.current.scrollTop;
    if (currentY > prevScrollY.current) {
      setShowFollowers(false);
    } else {
      setShowFollowers(true);
    }
    prevScrollY.current = currentY;
  };

  useEffect(() => {
    const sc = scrollContainerRef.current;
    if (sc) {
      sc.addEventListener("scroll", handleScroll);
      return () => sc.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <>
      <Loading loading={loading} />

      {!isMobile ? (
        <Layout className="profile-section-layout">
          <Header className="profile-section-header">
            <div className="search-bar-container">
              <NewNavBar />
            </div>
          </Header>
          <Layout className="profile-section-layout">
            <Content
              className="profile-section-content"
              ref={scrollContainerRef}
              style={{ overflowY: "auto" }}
            >
              <UserHeaderProfile />
              <div className="profile-user-section">
                <div
                  className={`profile-desktop-inner ${
                    showFollowers ? "" : "profile-desktop-inner--no-followers"
                  }`}
                >
                  <div className="profile-col">
                    <UserSider />
                  </div>

                  <div className="profile-main-content">
                    {routes}
                  </div>

                  {showFollowers && (
                    <div className="profile-col-1">
                      <FollowersSider
                        uiTexts={texts}
                        following={following}
                        followers={followers}
                        connections={connections}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Content>
          </Layout>
        </Layout>
      ) : (
        <Layout className="profile-section-layout">
          <Header className="profile-section-header">
            <div className="search-bar-container">
              <NewNavBar />
            </div>
          </Header>
          <Layout className="profile-section-layout">
            <Content className="profile-section-content">
              <UserHeaderProfile />
              <div className="profile-section-container">
                <div className="profile-col">
                  <div className="profile-col-1">
                    <FollowersSider
                      uiTexts={texts}
                      following={following}
                      followers={followers}
                      connections={connections}
                    />
                  </div>
                </div>
                <div className="profile-mobile-content">{routes}</div>
              </div>
              <NewSideBar />
            </Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default LayoutProfile;
